<template>
  <div class="q-pa-md q-gutter-sm">
    <q-breadcrumbs>
      <q-breadcrumbs-el icon="home" to="/" />
      <q-breadcrumbs-el label="商品管理" icon="widgets" to="/mp/product" />
      <q-breadcrumbs-el
        label="商品详情"
        icon="widgets"
        to="/mp/product/detail"
      />
    </q-breadcrumbs>
    <div class="row q-gutter-md justify-center">
      <div class="col-8" style="text-align: center">
        <h5>商品信息</h5>
      </div>
      <div class="col-8">
        <q-input
          outlined
          v-model="product.productName"
          label="商品名称"
          :dense="dense"
        >
        </q-input>
      </div>
      <div class="col-8">
        <q-input outlined v-model="product.brand" label="品牌" :dense="dense">
        </q-input>
      </div>
      <div class="col-8">
        商品类型
        <q-radio
          v-model="product.productType"
          val="0"
          label="加工"
          color="teal"
        />
        <q-radio
          v-model="product.productType"
          val="1"
          label="色纱"
          color="orange"
        />
        <q-radio
          v-model="product.productType"
          val="2"
          label="胚纱"
          color="orange"
        />
      </div>
      <div class="col-8">
        <q-select
          outlined
          v-model="product.yarnType"
          :options="yarnList"
          option-label="typeName"
          option-value="id"
          emit-value
          map-options
          label="纱支类型"
          :dense="dense"
          clearable
        />
      </div>
      <div class="col-8">
        <q-uploader
          ref="uploader"
          label="主图"
          :factory="factoryFn"
          color="teal"
          flat
          bordered
          @uploaded="uploaded"
          @removed="removed"
        />
      </div>
      <div class="col-8">
        <q-uploader
          ref="picListUploader"
          label="图片列表"
          color="teal"
          flat
          bordered
          multiple
          :factory="factoryFn"
          @uploaded="picListUploaded"
          @removed="picListRemoved"
        />
      </div>
      <div class="col-8">
        <q-input
          outlined
          v-model="product.productDesc"
          label="商品描述"
          type="textarea"
          clearable
        >
        </q-input>
      </div>
      <div class="col-8">
        <q-input
          outlined
          v-model="product.price"
          label="基础价格"
          clearable
          :dense="dense"
        >
        </q-input>
      </div>
      <div class="col-8">
        <q-input
          outlined
          v-model="product.unit"
          label="单位"
          :dense="dense"
          clearable
        >
        </q-input>
      </div>
      <div class="col-8">
        <q-input
          outlined
          v-model="product.seq"
          label="顺序"
          :dense="dense"
          clearable
        >
        </q-input>
      </div>
      <div class="col-8">
        <q-input
          outlined
          v-model="product.remark"
          label="备注"
          type="textarea"
          clearable
        >
        </q-input>
      </div>
      <div class="col-8 q-gutter-x-md" style="text-align: center">
        <q-btn label="保存" color="primary" @click="save" />
        <q-btn flat label="取消" color="primary" @click="cancel" />
      </div>
    </div>
  </div>
</template>

<script>
import { list as listYarn } from "@/api/erp/yarn.js";
import { save, update, detail } from "@/api/mp/product";
import { getImageFileFromUrl } from "@/utils/file";
export default {
  data() {
    return {
      dense: true,
      product: {},
      yarnList: [],
      headers: [
        {
          name: "Authorization",
          value: "Bearer " + localStorage.getItem("token"),
        },
      ],
      url: process.env.VUE_APP_BASE_URL + "file/banner/upload",
    };
  },
  methods: {
    listYarn() {
      var self = this;
      listYarn().then((response) => {
        self.yarnList = response.data.data;
      });
    },
    detail(id) {
      detail(id).then((response) => {
        this.product = response.data.data;
        if (this.product.pics) {
          this.product.pics = JSON.parse(this.product.pics);
          for (let index = 0; index < this.product.pics.length; index++) {
            getImageFileFromUrl(this.product.pics[index]).then((file) => {
              this.$nextTick(() => {
                let files = [];
                files.push(file);
                this.$refs.picListUploader.addFiles(files);
              });
            });
          }
        } else {
          this.product.pics = [];
        }
        if (this.product.productPic) {
          let fileList = [];
          getImageFileFromUrl(this.product.productPic).then((file) => {
            fileList.push(file);
            this.$nextTick(() => {
              this.$refs.uploader.addFiles(fileList);
            });
          });
        }
      });
    },
    save() {
      this.product.pics = JSON.stringify(this.product.pics);
      if (this.product.id) {
        update(this.product).then(() => {
          this.$q.notify({ type: "positive", message: "更新成功" });
          if (this.product.pics) {
            this.product.pics = JSON.parse(this.product.pics);
          }
        });
      } else {
        save(this.product).then((response) => {
          this.$q.notify({ type: "positive", message: "保存成功" });
          this.product.id = response.data.data;
          if (this.product.pics) {
            this.product.pics = JSON.parse(this.product.pics);
          }
        });
      }
    },
    cancel() {
      this.$router.back();
    },
    uploaded(info) {
      var res = JSON.parse(info.xhr.response);
      this.product.productPic = res.data.url;
    },
    removed() {
      this.product.productPic = null;
    },
    picListUploaded(info) {
      var res = JSON.parse(info.xhr.response);
      this.product.pics.push(res.data.url);
    },
    picListRemoved(files) {
      console.log(files);
      files.forEach((file) => {
        if (file.__status == "uploaded") {
          var res = JSON.parse(file.xhr.response);
          for (let i = 0; i < this.product.pics.length; i++) {
            if (this.product.pics[i] == res.data.url) {
              this.product.pics.splice(i, 1);
            }
          }
        } else {
          for (let i = 0; i < this.product.pics.length; i++) {
            if (this.product.pics[i].indexOf(file.name) > -1) {
              this.product.pics.splice(i, 1);
            }
          }
        }
      });
      console.log(this.product.pics);
    },
    factoryFn() {
      const token = localStorage.getItem("token");
      // returning a Promise
      return new Promise((resolve) => {
        resolve({
          url: process.env.VUE_APP_BASE_URL + "file/banner/upload",
          fieldName: "file",
          headers: [
            {
              name: "Authorization",
              value: `Bearer ${token}`,
            },
          ],
        });
      });
    },
  },
  mounted() {
    this.listYarn();
    if (this.$route.query.id) {
      this.detail(this.$route.query.id);
    }
  },
};
</script>

<style scoped>
</style>